import { create } from 'zustand';

import type { GlobalCopilotContext } from './types';

export interface GlobalCopilotContextState {
  readonly sessionOperationContextData: GlobalCopilotContext | null;
  readonly replaceSessionOperationContextData: (sessionOperationContextData: GlobalCopilotContext) => void;
  readonly clearSessionOperationContextData: () => void;
  readonly isUsingContext: boolean;
  readonly setIsUsingContext: (isUsingContext: boolean) => void;
}

const getInitialContextState = (): Pick<
  GlobalCopilotContextState,
  'isUsingContext' | 'sessionOperationContextData'
> => ({
  isUsingContext: false,
  sessionOperationContextData: null,
});

export const useGlobalCopilotContextStore = create<GlobalCopilotContextState>((set) => ({
  ...getInitialContextState(),
  replaceSessionOperationContextData: (sessionOperationContextData) => {
    set({ sessionOperationContextData, isUsingContext: true });
  },
  clearSessionOperationContextData: () => {
    set(getInitialContextState());
  },
  setIsUsingContext: (isUsingContext) => {
    set({ isUsingContext });
  },
}));
